import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo/logo.png";
import { solutionsContent } from "../../assets/data/contentData";

const Header = ({ activeSolId, onSolChange }) => {
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    const onScroll = () => setScroll(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleLogin = () => {
    window.location.href = "https://ikhnuden.intellx.mn";
  };

  return (
    <>
    <header style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 1100,
      transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
      background: scroll ? "rgba(7, 10, 41, 0.95)" : "transparent",
      backdropFilter: scroll ? "blur(30px)" : "none",
      borderBottom: scroll ? "1px solid rgba(255,255,255,0.08)" : "1px solid transparent",
      padding: "0 30px",
    }}>
      <div style={{
        maxWidth: "1440px", margin: "0 auto",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        height: scroll ? "70px" : "90px", transition: "height 0.4s ease"
      }}>
        {/* Logo Section */}
        <div style={{ flex: "0 1 auto" }}>
            <Link to="/" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <img src={logo} alt="INTELLX" style={{ height: scroll ? "28px" : "32px", transition: "height 0.3s" }} />
            </Link>
        </div>

        {/* Center: Solutions Hub (Desktop Only) */}
        <nav className="d-none d-lg-flex" style={{ gap: "5px", flex: "1", justifyContent: "center" }}>
            {Object.values(solutionsContent).map((s) => (
              <button
                key={s.id}
                onClick={() => onSolChange(s.id)}
                style={{
                  padding: "10px 18px", background: "transparent", border: "none",
                  color: activeSolId === s.id ? "#fff" : "rgba(255,255,255,0.4)",
                  cursor: "pointer", fontSize: "10px", fontFamily: "'Conthrax', sans-serif",
                  letterSpacing: "1.2px", transition: "all 0.3s",
                  textTransform: "uppercase", position: "relative"
                }}
              >
                {s.brand}
                {activeSolId === s.id && (
                  <div style={{
                    position: "absolute", bottom: "-5px", left: "20%", right: "20%",
                    height: "2px", background: s.color, boxShadow: `0 0 10px ${s.color}`
                  }} />
                )}
              </button>
            ))}
        </nav>

        {/* Right Action Section */}
        <div style={{ flex: "0 1 auto", display: "flex", justifyContent: "flex-end" }}>
            {activeSolId === "media" ? (
                <button onClick={handleLogin} style={{
                    background: "linear-gradient(135deg, #5C27FE, #7C3AED)",
                    border: "none", borderRadius: "50px", padding: "8px 20px",
                    color: "#fff", fontSize: "9px", fontFamily: "'Conthrax', sans-serif",
                    cursor: "pointer", boxShadow: "0 8px 20px rgba(92,39,254,0.4)",
                    whiteSpace: "nowrap"
                }}>
                    <span className="d-none d-md-inline">ACCESS DASHBOARD →</span>
                    <span className="d-inline d-md-none">ACCESS →</span>
                </button>
            ) : (
                <div style={{
                    fontSize: "8px", color: "rgba(255,255,255,0.25)", 
                    fontFamily: "'Conthrax', sans-serif", border: "1px solid rgba(255,255,255,0.1)",
                    padding: "6px 12px", borderRadius: "50px", whiteSpace: "nowrap"
                }}>
                    SECURE NODE
                </div>
            )}
        </div>
      </div>
    </header>

    {/* Mobile Selector - 3-row, 2-column Grid for full text visibility */}
    <div className="d-lg-none" style={{
        position: "fixed", top: scroll ? "75px" : "95px", left: "5%", right: "5%",
        width: "90%", zIndex: 1090, transition: "all 0.4s ease"
    }}>
        <div style={{ 
            display: "grid", 
            gridTemplateColumns: "repeat(2, 1fr)", 
            gap: "8px",
            background: "rgba(7, 10, 41, 0.95)", backdropFilter: "blur(25px)",
            border: "1px solid rgba(255,255,255,0.08)", borderRadius: "15px",
            padding: "12px"
        }}>
            {Object.values(solutionsContent).map((s) => (
                <button
                    key={s.id}
                    onClick={() => onSolChange(s.id)}
                    style={{
                        padding: "10px 5px", borderRadius: "8px",
                        background: activeSolId === s.id ? `${s.color}20` : "transparent",
                        color: activeSolId === s.id ? s.color : "rgba(255,255,255,0.35)",
                        fontSize: "8px", fontFamily: "'Conthrax', sans-serif",
                        whiteSpace: "nowrap", border: `1px solid ${activeSolId === s.id ? `${s.color}30` : "transparent"}`,
                        outline: "none", transition: "all 0.2s",
                        textAlign: "center", textTransform: "uppercase"
                    }}
                >
                    {s.brand}
                </button>
            ))}
        </div>
    </div>

    <style>{`
        .no-scrollbar::-webkit-scrollbar { display: none; }
    `}</style>
    </>
  );
};

export default Header;
